import type { IconProps } from './icon-types.js';

/** Ikona volby "Tmavý" v přepínači motivu (UserMenu, FR01 PART1 FR-15). */
export function MoonIcon({ width = 18, height = 18, ...props }: IconProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} {...props}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M20.5 14.7A8.5 8.5 0 1 1 9.3 3.5a7 7 0 0 0 11.2 11.2Z" />
    </svg>
  );
}
